module.exports = __webpack_public_path__ + "img/2.1b974505.png";